module.exports = __webpack_public_path__ + "img/Logo_IPSS.e6c36081.png";